import {ThemedStyleSheet} from '../../Utils/ThemedStyleSheet';
import {Spacing} from '../../Styles';

export default ThemedStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    paddingTop: Spacing.small,
    paddingBottom: Spacing.large,
  },
  headerCard: {
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    padding: Spacing.small,
    marginBottom: Spacing.normal,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  pickerWrapper: {
    marginTop: Spacing.small,
  },

  answerItem: {
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    padding: Spacing.small,
    marginVertical: Spacing.small,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  answerItemAnswer: {
    marginLeft: 38,
    marginTop: 6,
    color: theme.colors.textLight,
  },

  switch: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  switchText: {
    marginRight: 12,
    color: theme.colors.textStrong,
  },

  questionContent: {
    paddingVertical: Spacing.small,
  },
  questionCard: {
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.small,
    borderWidth: 1,
    borderColor: theme.colors.border,
  },
  strongBody: {
    color: theme.colors.textStrong,
  },
  progressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: Spacing.xsmall,
    marginBottom: Spacing.xxsmall,
  },
  progressText: {
    color: theme.colors.textLight,
    flexShrink: 1,
    fontSize: 13,
    lineHeight: 20,
  },
  progressBar: {
    height: 6,
    borderRadius: 3,
    backgroundColor: theme.colors.secondary,
  },
  privacyReminder: {
    marginTop: Spacing.xsmall,
    color: theme.colors.textLight,
    lineHeight: 21,
  },
  sensitiveNotice: {
    marginTop: Spacing.xsmall,
    padding: Spacing.xsmall,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.error,
    backgroundColor: theme.colors.urgentSurface,
  },
  submitButton: {
    marginTop: Spacing.small,
    borderRadius: 8,
  },
  pauseButton: {
    marginTop: Spacing.xsmall,
  },
  earlyStopSection: {
    marginTop: Spacing.small,
  },
  earlyStopButton: {
    marginTop: Spacing.xxsmall,
  },
  earlyStopHint: {
    marginTop: Spacing.xxsmall,
    color: theme.colors.textLight,
  },
  recommendedQuestionIndex: {
    color: theme.colors.textLight,
    marginTop: Spacing.small,
    marginBottom: Spacing.xxsmall,
  },
  listContent: {
    paddingBottom: Spacing.large,
  },
}));
